/*
PERMANENT CHANGE FOR SCORE`S SlickSlider 
*/
; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/ScoreHotfix/SlickSlider',["jquery", "slick", "SageDotCom/Components/SlickSliderSettings",], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("slick")) :
            console && console.error('Slick Slider does not support non-amd script loading.');
}(this/* window */, function ($, slick, SlickSliderSettings) {

    function SlickSlider(args) {
        var scope = args.scope;
        var self = this;

        //this function creates the settings object for slick
        var slickSettings = SlickSliderSettings.getSlickSliderSettings(args); 

        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });
        Object.defineProperty(this, 'lastDirection', { enumerable: !1, value: void 0, writable: !0 }); 

        new Promise(function(resolve, reject) {

            var slickSlider = self.$scope.slick(slickSettings)[0].slick;

            Object.defineProperty(self,
                'slider',
                { enumerable: !0, value: slickSlider, writable: !1, configurable: !0 });

            slickSlider.slideHandler = self._captureDirection.bind(self, slickSlider, slickSlider.slideHandler);
            self.$scope.on('afterChange', self._onAfterChangeSlide.bind(self));
            self.$scope.on('beforeChange', self._onBeforeChangeSlide.bind(self));

            resolve();
        });
    }

    /**
     * Capture slider direction, it can be done only with raw parameters received in slideHandler function.
     * @param {} slider an instance of a slider, to run the original function in a context of it
     * @param {} baseFn a reference to the original slideHandler function
     * @param {} index unmodified index number, to understand direction
     * @returns {} 
     */
    SlickSlider.prototype._captureDirection = function (slider, baseFn, index) {
        this.lastDirection = index > slider.currentSlide ? 'left' : 'right';
        baseFn.apply(slider, Array.prototype.slice.call(arguments, 2));
    }

    /**
     * Notify the world about slide is going to be changed
     */
    SlickSlider.prototype._onBeforeChangeSlide = function () {
        $(this).trigger('beforeChange.slider', [this, this.lastDirection]);
    }

    /**
     * Notify the world about slide was changed
     * @param {jQuery.Event} event from bootstrap carousel 
     */
    SlickSlider.prototype._onAfterChangeSlide = function () {
        $(this).trigger('afterChange.slider', [this, this.lastDirection]);

        // pause any score brightcove videos that may be inside
        var brightcoveJsVideos = $(this.scope).find(".brightcove-media-container-js .video-js");
        brightcoveJsVideos.each(function () {
            var videoId = $(this).attr("id");
            videojs.getPlayer(videoId).pause();
        });
    };

    SlickSlider.init = function (args) {
        if (args.IsEditorEditing) return null;

        var slick = new SlickSlider(args);

        if (args.xPerienceXml && args.xPerienceXml.length > 0) {
            require(["XP/XPRuleLoader"], function (module) {
                var ruleLoader = module.hasOwnProperty('XPRuleLoader') && module.XPRuleLoader instanceof Function ? new module.XPRuleLoader() /* named load */
                    : module.__esModule === !0 && module.hasOwnProperty("default") && module.default instanceof Function ? new module.default() /* default module load */
                        : module instanceof Function ? new module() /* old fashioned modules */
                            : console.log('Cannot load XPRuleLoader module to load XPerience Rules');

                if (ruleLoader) {
                    ruleLoader.applyRules(slick, args.xPerienceXml);
                }
            });
        }

        return slick;
    }

    return SlickSlider;
}));
